import * as React from 'react';

type CheckIconProps = {
  size?: number;
  color?: string;
  className?: string;
  'data-testid'?: string;
};

const CheckIcon = ({
  size = 12,
  color = 'white',
  className,
  'data-testid': dataTestId = 'check-icon',
}: CheckIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    className={className}
    data-testid={dataTestId}
    aria-hidden="true"
  >
    <path
      d="M4.8625 7.3877L8.6 3.6502C8.69092 3.55853 8.79696 3.5127 8.91813 3.5127C9.03938 3.5127 9.14583 3.55853 9.2375 3.6502C9.32917 3.74186 9.375 3.84845 9.375 3.96995C9.375 4.09145 9.33079 4.1964 9.24238 4.28482L5.1875 8.3502C5.09658 8.44186 4.99054 8.4877 4.86937 8.4877C4.74812 8.4877 4.64167 8.44186 4.55 8.3502L2.7625 6.5627C2.67083 6.47103 2.625 6.36478 2.625 6.24395C2.625 6.12311 2.67083 6.01686 2.7625 5.9252C2.85417 5.83353 2.96112 5.7877 3.08337 5.7877C3.20554 5.7877 3.31108 5.83353 3.4 5.9252L4.8625 7.3877Z"
      fill={color}
      stroke={color}
      strokeWidth="0.5"
    />
  </svg>
);

export default CheckIcon;
